module.exports = __webpack_public_path__ + "static/media/ruble-sign.d68d92e5.svg";